#import "../fragments/dashboard-stats-fragment.graphql"

query GetConnectedFormsDashboard($input: DashboardInput!) {
    connectedFormsDashboard(input: $input) {
        stat {
            ...DashboardStatsFragment
        }
        numForms
        topForms {
            form {
                id
                name
                htmlUrlPath
            }
            views
            submissions
        }
    }
}
